import { auth } from "./FirebaseConfig";
import { GoogleAuthProvider, signInWithPopup} from "firebase/auth";



const provider = new GoogleAuthProvider();
provider.addScope("https://www.googleapis.com/auth/userinfo.profile")
export const SignInGoogle = async () => {
    return await signInWithPopup(auth, provider)
}